import { Box } from "@mui/system";
import React from "react";

export const LabelWithControl = ({ label, labelId, required, children, labelVisible }) => {
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', textAlign: 'left' }}>
                <label htmlFor={labelId} style={{ visibility: labelVisible }}>{label} {required ? <span style={{ color: '#d32f2f' }}>*</span> : ''}</label>
                {children}
            </Box>
        </>
    )
}